import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'semantic-ui-react';
import classnames from 'classnames';
import * as shared from '../assets/shared.module.scss';
import * as classes from './classes.module.scss';

const WorkTitle = ({
  imageUrl, title, authorName, large, medium, isHidden, children
}) => {
  const hidden = isHidden ? (
    <Icon name="eye slash" />
  ) : null;

  const className = classnames(
    classes.image, {
      [classes.medium]: medium,
      [classes.large]: large
    }
  );

  // TODO: refactor with base_work
  return (
    <div className={ classes.details }>
      <div className={ className }>
        <img src={ imageUrl } alt={ title } />
      </div>
      <div className={ classnames(shared.title, shared.noPadding) }>
        <strong>
          { hidden }
          { title }
        </strong>
        <span>
          by&nbsp;
          { authorName }
        </span>
        { children }
      </div>
    </div>
  );
};

WorkTitle.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  authorName: PropTypes.string.isRequired,
  medium: PropTypes.bool,
  large: PropTypes.bool,
  isHidden: PropTypes.bool,
  children: PropTypes.node
};

export default WorkTitle;
